// src/components/JollyRogerClub/JollyRogerClub.js

import React from "react";
import "../../styles/ijrr.css";
import "./JollyRogerClub.css";

export default function JollyRogerClub() {
  return (
    <div>
      {/* Jolly Roger Club Section */}
      <section className="about-us space-pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              
              {/* Logo Section positioned above the title */}
              <div className="club-logo-wrapper">
                <img 
                  src="/assets/images/ijrr/IJRR-CLUB.png" 
                  alt="Jolly Roger Club Logo" 
                  className="img-fluid club-main-logo"
                />
              </div>

              <h2 className="original-title gold-text">
                JOLLY ROGER CLUB
              </h2>
              <br />
              <p className="ijrr-text">
                Welcome to the Jolly Roger Club, where pirates at heart gather to share their stories, support each other, and celebrate the spirit of freedom that defined the Golden Age of Piracy. Our club is a growing community of individuals who believe in independence, creativity, and building a personal brand that truly represents who they are.
              </p>
              <br />
              <p className="ijrr-text">
                As a member of the Jolly Roger Club, you will gain access to exclusive updates about pirate festivals, online and in-person events, and unique merchandise that celebrates your journey. You will have opportunities to showcase your image, connect with fellow members, and participate in challenges and contests that are both fun and rewarding.
              </p>
              <br />
              <p className="ijrr-text">
                We believe that every member of our club adds value to our community. Whether you are here to find inspiration, learn more about the pirate lifestyle, or to showcase your personal flag, the Jolly Roger Club is here to support you on your journey.
              </p>
              <br />
              <p className="ijrr-text">
                Thank you for being part of the Jolly Roger International Family. We look forward to seeing your flag fly high as you navigate your own adventure under the Jolly Roger.
              </p>
              <br />
              <h3>
                <i>
                  “Join the Jolly Roger Club today and sail into your new adventure.”
                </i>
              </h3>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}